import { render } from "./messages.vue?vue&type=template&id=bfc6ae08&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import "./messages.vue?vue&type=style&index=0&id=bfc6ae08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc6ae08"]])

export default __exports__